export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div>
            <span className="font-heading text-2xl text-primary-400 block mb-4">吃瓜入口</span>
            <p className="text-sm text-foreground-300 leading-relaxed">
              每日大赛吃瓜入口，汇集最新视频与系列内容，入口每日更新，大赛吃瓜在线直达。不再错过任何一期精彩大赛爆料。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">快捷导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">焦点专题</a>
              <a href="#media" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">视频精选</a>
              <a href="#comments" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">网友热议</a>
              <a href="#contact" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">爆料投稿</a>
              <a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热门吃瓜</a>
              <a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">吃瓜热度榜</a>
              <a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">话题热榜</a>
              <a href="#index" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">专题合集</a>
              <a href="#features" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">平台特色</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              与多家内容平台及媒体机构保持合作关系，共同打造优质大赛吃瓜内容生态。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            &copy; 2024-2026 吃瓜入口 — 每日大赛吃瓜入口更新。本站内容仅供娱乐参考，不构成任何商业建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">回到顶部</a>
            <span className="text-xs text-foreground-400 whitespace-nowrap">每日更新 · 大赛吃瓜在线</span>
          </div>
        </div>
      </div>
    </footer>
  );
}